{
 "generator": "tools/make-structtex.mjs",
 "generator_sha": "5cda712a215d8c528bad5d685738e0df67cbe55a95682d3058206df147aee59b",
 "textures": {
  "masonry": {
   "file": "masonry.jpg",
   "sha256": "7e499261e844f91e4b17f00dd159dd7f840624e9e9ec4f77c3f96bc6a05fab2f",
   "repeat_m": 3.2,
   "size_px": 1024,
   "mean_lin": [
    0.39299,
    0.40707,
    0.32714
   ],
   "albedo_hex": "#919385",
   "joint_frac": 0.071,
   "source": {
    "id": "rock_wall_12",
    "author": "Amal Kumar",
    "url": "https://polyhaven.com/a/rock_wall_12",
    "licence": "CC0 1.0",
    "tile_m": 1.6,
    "sha": {
     "diff": "e8b7d0501d456041bf2b599a900114617c84444ee08279f655ddae693e65a0bd",
     "disp": "5a4c5ca51377ae44add8c1120f2cbbf5c0812e18499b2e40a7e7114e761de4cb"
    },
    "maps": [
     "diff",
     "disp"
    ],
    "resolution": "2k"
   }
  }
 }
}
